import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import CategoryTabs from "./categoryTabs";
export const CategoryManagement = () => {
  const { t } = useTranslation("common");

  return (
    <Flex direction="column" height="100%" bg="white" padding={"24px 16px"}>
      <Text fontSize="2xl" fontWeight="bold" mb={1}>
        {t("categoryManagement.title")}
      </Text>
      <Text color="gray.500" mb={6}>
        {t("categoryManagement.subtitle")}
      </Text>
      <CategoryTabs />
    </Flex>
  );
};

export default CategoryManagement;
